import { useEffect } from 'react';
import headerImg from '../images/header.jpg';
import StepOne from '../components/StepOne';
import StepTwo from '../components/StepTwo';
import StepThree from '../components/StepThree';
import StepFour from '../components/StepFour';
import StepFive from '../components/StepFive';
import StepSix from '../components/StepSix';

import { useState } from 'react';
import Thankyou from '../components/Thankyou';
import axios from 'axios';

const SeaOpportunities = ({backHome}) => {

    const [step, setStep] = useState(1);
    const [thankyouPage, setThankyouPage] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
 
    //state for form data
    const [formData, setFormData] = useState([]);
    
    // function for going to next step by increasing step state by 1
    const nextStep = () => {
        if(step < 6)
        {
        setStep(step + 1);
        }
    };
    
    // function for going to previous step by decreasing step state by 1
    const prevStep = () => {
        setStep(step - 1);
    };

    // handling form input data by taking onchange value and updating our previous form data state
    const handleInputData = (input) => {
        if(input)
        {
            console.log(input)
            //updating for data state taking previous state and then adding new value to create new object
            setFormData(prevState => ({
            ...prevState,
            ...input
            }));
        }

    if(step == 6){
        try{
        setSubmitLoading(true);
        const submitData  = new FormData();

		if(formData)
		{
		Object.keys(formData).map((item, i) => {
			submitData.append(item, formData[item]);
		});
		}
        if(input)
        {
        Object.keys(input).map((item, i) => {
            if(item == 'documents')
            {
                console.log(input['documents'])
                Object.keys(input[item]).map((opp, i) => {
                    submitData.append('file[]', input['documents'][opp]);
                });
            }else{
            submitData.append(item, input[item]);
            }
        });
        }
        setTimeout(() => {
          let finalFormEndpoint = "https://goaship.com/admin/api/Sea";
        //let finalFormEndpoint = "http://localhost/cias/api/Sea";
        axios.post(finalFormEndpoint, submitData)
            .then(function (response) {
            setThankyouPage(true);
            setFormData([]);
            setStep(1);
            setSubmitLoading(false);
            })
            .catch(function (error) {
            console.log(error);
            });
        }, 400);
        }catch(e){
            console.log(e)
        }
    }
    }

    return (
    <div className="h-screen">

        <nav className="flex items-center justify-between w-full absolute t-0 z-50 flex-wrap px-6 py-1">
        <div className="flex items-center flex-shrink-0 text-white mr-6 mt-4 ">
            <a href="http://hermesmaritime.com/">
            <span className="icon-hermes">
                <span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span><span className="path14"></span><span className="path15"></span><span className="path16"></span></span>
            </a>
        </div>
        <div className="block lg:hidden">
            <button className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white">
            <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
            </button>
        </div>
        <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
        </div>
        </nav>

	<div className="relative overflow-hidden bg-no-repeat bg-cover" style={{
    backgroundPosition: '50%', backgroundImage: `url(${headerImg})`,
    height: '450px'
    }}>

        <div className="absolute top-0 right-0 bottom-0 left-0 w-full h-full overflow-hidden bg-fixed"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.45)' }}>
        <div className="flex justify-center items-center h-full">
            <div className="text-center text-white px-6 pt-12 md:px-12">
            <h1 className="text-5xl font-bold mt-0 mb-6">Sea Opportunities</h1>
            <h4 className="text-md mb-8 px-8">Hermes Ship Management offers maritime jobs onboard offshore DSV, AHTS, PSV & ROV support vessels including Tankers, Bulk carrier,Passenger, Container, General Cargo and other specialized Vessels, as well as shore side vacancies within the maritime sector.</h4>
                <a href='/' className="bg-transparent hover:bg-orange-500 text-orange-700 font-semibold hover:text-white py-2 px-4 border border-orange-500 hover:border-transparent rounded">
                Back to Home
                </a>
            </div>
        </div>
        </div>
    </div>

    {thankyouPage ?
	<div className="lg:px-48 items-center justify-center">
	<div className="w-full px-4 pt-10">

		<div>	
			<div className="py-10">	
				
				<Thankyou setThankyouPage={setThankyouPage} />
				
			</div>
		</div>
	</div>
	</div>
	:
    <div class="lg:px-48 items-center justify-center">
		<div class="w-full px-4 pt-10">
            {step == 1 ?
                <StepOne step={step} nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} values={formData} />
            : step == 2 ?
                <StepTwo step={step} nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} values={formData} /> 
            : step == 3 ?
                <StepThree step={step} nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} values={formData} /> 
            : step == 4 ?
                <StepFour step={step} nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} values={formData} /> 
            : step == 5 ?
                <StepFive step={step} nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} values={formData} /> 
            : step == 6 ?
                <StepSix step={step} submitLoading={submitLoading} nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} values={formData} setFormData={setFormData} /> 
            : null
            }
        </div>
    </div>
    }
	</div>
    )
}

export default SeaOpportunities;